import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';

import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { Form, Button } from 'react-bootstrap';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect';
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllStock = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({ location: '', product_name: '' });

  // Handle filter changes
  const handleFilterChange = (e: React.ChangeEvent<any>) => {
    const target = e.target as HTMLInputElement | HTMLSelectElement;
    setFilters(prev => ({
      ...prev,
      [target.name]: target.value
    }));
  };

  // Function to return actions for each row
  const getActions = (stock_id: string, product_id: string): ActionItem[] => [
    {
      eventKey: '1',
      label: 'Edit Stock',
      type: 'function',
      callback: () => navigate(`/inventory/stock/edit-stock/${stock_id}`)
    },
    {
      eventKey: '2',
      label: 'Delete Stock',
      type: 'function',
      className: 'text-danger'
    }
    // {
    //   eventKey: '3',
    //   label: 'View Product',
    //   type: 'function',
    //   callback: () => navigate(`/inventory/products/${product_id}`)
    // }
  ];

  const columns = [
    { accessorKey: 'stock_id', header: 'Stock ID' },
    { accessorKey: 'product.product_name', header: 'Product Name' },
    { accessorKey: 'product.category', header: 'Category' },
    { accessorKey: 'location', header: 'Location' },
    { accessorKey: 'quantity', header: 'Quantity' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(
                row.original.stock_id,
                row.original.product_id
              )}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <div>
      <h2>All Inventory Stock</h2>

      {/* Filters Section */}
      <Form className="mb-3 d-flex gap-3">
        <Form.Group>
          <Form.Label>Product Name</Form.Label>
          <Form.Control
            type="text"
            name="product_name"
            value={filters.product_name}
            onChange={handleFilterChange}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Location</Form.Label>
          <Form.Control
            type="text"
            name="location"
            value={filters.location}
            onChange={handleFilterChange}
          />
        </Form.Group>

        <Button variant="primary" className="align-self-end">
          Apply Filters
        </Button>
      </Form>

      {/* List Data Page */}
      <ListDataPage
        apiHook={apiHooks.useInventoryStock}
        entityName="Stock"
        columns={columns}
      />
    </div>
  );
};

export default AllStock;
